import classNames from 'classnames';
import type { ApiErrorMessage } from 'epic/apiErrorEpicHelper';
import { FC, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

type CancelButtonProps = {
  className?: string;
  error?: ApiErrorMessage;
  onCancel?: () => void;
};
export const CancelButton: FC<CancelButtonProps> = ({ className, error, onCancel }) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const onClick = useCallback(() => {
    if (onCancel) {
      onCancel();
      logAnalytics.trackEvent(logAnalyticsCategory, 'Cancel price improvement');
    }
  }, [logAnalyticsCategory, onCancel]);

  const { formatMessage } = useIntl();

  return (
    <button
      className={classNames('btn btn-discreet-danger btn-lg my-0', className)}
      data-e2e="price-negotiation-cancel-btn"
      onClick={onCancel && onClick}
      type="button"
      disabled={!onCancel}
    >
      {error && <em className="icon me-2">report_problem</em>}
      {formatMessage({ id: 'priceImprovement.cancel.button.label' })}
    </button>
  );
};
